module.exports = require("body-parser");


//////////////////
// WEBPACK FOOTER
// external "body-parser"
// module id = 12
// module chunks = 0